export const PROFILE_DETAILS_CONTENT_MAX_HEIGHT = 33.5;
export const PROFILE_DETAILS_POPOVER_HEIGHT = 54;
export const PROFILE_DETAILS_POPOVER_WIDTH = 51;
